import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import ShippingAddressCard from 'components/account/ShippingAddressCard';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_KRATOS_PAYMENTS_ADDRESS_PAGES_RELEASE } from 'constants/features';
import { ADD_NEW_ADDRESS_ROUTE, KRATOS_ADD_NEW_ADDRESS_ROUTE } from 'constants/routes';
import { cn } from 'helpers/classnames';

import styles from 'styles/components/account/cardLayout.scss';

export const ShippingCardLayout = ({ addresses, onDelete, onPrimary, onAddNewAddress }, { testId }) => {
  const defaultShippingAddress = addresses.find(address => address.isDefaultShippingAddress);
  const otherShippingAddresses = addresses.filter(address => !address.isDefaultShippingAddress);

  const { isEnrolled: isKratosPaymentsAddressesPagesRelease } = useIsEnrolledInVariant({
    featureFlag: FEATURE_KRATOS_PAYMENTS_ADDRESS_PAGES_RELEASE,
    isZapposOnly: false
  });

  return (
    <div>
      {defaultShippingAddress && (
        <div className={styles.defaultCard} data-test-id={testId('defaultShippingAddress')}>
          <h2 className="zappos:heading-m">Default Shipping Address</h2>
          <ul>
            <ShippingAddressCard address={defaultShippingAddress} onDelete={onDelete} onPrimary={onPrimary} />
          </ul>
        </div>
      )}
      <div className={styles.otherCards}>
        {defaultShippingAddress ? (
          <h2 className="zappos:heading-m">Other Shipping Addresses</h2>
        ) : (
          <h2 className="zappos:heading-m">Shipping Addresses</h2>
        )}
        {!addresses.length ? (
          <div className={cn(styles.empty, 'zappos:body-m')} data-test-id={testId('noAddressesSaved')}>
            There are no addresses associated with this account.
          </div>
        ) : null}
        <MartyLink
          to={isKratosPaymentsAddressesPagesRelease ? KRATOS_ADD_NEW_ADDRESS_ROUTE : ADD_NEW_ADDRESS_ROUTE}
          className={styles.addNewItem}
          onClick={onAddNewAddress}
          data-test-id={testId('addNewShippingAddress')}
        >
          Add New Address
        </MartyLink>
        <ul className={styles.cardGrid}>
          {otherShippingAddresses.map((address, index) => (
            <ShippingAddressCard
              key={address.addressId}
              addressIndex={index} // for amethyst event
              address={address}
              onDelete={onDelete}
              onPrimary={onPrimary}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

ShippingCardLayout.contextTypes = {
  testId: PropTypes.func
};

ShippingCardLayout.propTypes = {
  addresses: PropTypes.array,
  onDelete: PropTypes.func.isRequired,
  onPrimary: PropTypes.func.isRequired
};

ShippingCardLayout.displayName = 'ShippingCardLayout';

export default withErrorBoundary(ShippingCardLayout.displayName, ShippingCardLayout);
